import type { Agent, AgentEngineType, AgentStatus } from '@conversia/shared-types';
import type { Paginated } from '@/lib/types';
import { api } from './client';

/** Endpoints de agentes AI. Prefijo: /api/agents */

export interface ListAgentsParams {
  status?: AgentStatus;
  skip?: number;
  take?: number;
}

export interface CreateAgentInput {
  name: string;
  description?: string;
  systemPrompt: string;
  configJson?: Record<string, unknown>;
  channelIds?: string[];
  contactWhitelist?: string[];
  /** Motor de inferencia. 'cli' solo en instalaciones internas (la API lo valida). */
  engineType?: AgentEngineType;
  /** Modelo del motor API. null/ausente = default de la instalación. */
  model?: string | null;
}

export type UpdateAgentInput = Partial<
  Pick<Agent, 'name' | 'description' | 'systemPrompt' | 'status'> & {
    configJson: Record<string, unknown>;
    contactWhitelist: string[];
    engineType: AgentEngineType;
    model: string | null;
  }
>;

/** Catálogo de modelos (configurable en el server) con descripciones llanas. */
export interface CatalogModel {
  id: string;
  nombre: string;
  descripcion: string;
}

export const getModelCatalog = () =>
  api.get<{ modelos: CatalogModel[] }>('/api/agents/models');

export const listAgents = (params: ListAgentsParams = {}) =>
  api.get<Paginated<Agent>>('/api/agents', { query: params });

export const getAgent = (id: string) => api.get<Agent>(`/api/agents/${id}`);

export const createAgent = (input: CreateAgentInput) => api.post<Agent>('/api/agents', input);

export const updateAgent = (id: string, input: UpdateAgentInput) =>
  api.patch<Agent>(`/api/agents/${id}`, input);

/** Archivar (reversible; la API expone /archive, sólo ADMIN). */
export const archiveAgent = (id: string) => api.post<Agent>(`/api/agents/${id}/archive`);

/**
 * Borrado REAL (tanda ajustes-finales, sólo ADMIN). La API rechaza con 422
 * llano si el agente es default de un canal o tiene conversaciones abiertas.
 */
export const deleteAgent = (id: string) => api.del<{ deleted: boolean }>(`/api/agents/${id}`);
